import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import routes from "../router/routes";
import { Helmet } from "react-helmet";
import AppUtil from "utilities/AppUtil";
import { useSelector } from "react-redux";
// import { getAuthInfo } from "store/slices/auth";

const styles = makeStyles({
  authContainer: {
    top: 0,
    height: "auto",
    position: "relative",
    minHeight: "100vh",
  },
  bg: {
    color: "#FFF",
    border: 0,
    height: "100%",
    margin: 0,
    display: "flex",
    position: "relative",
    minHeight: "100vh",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center",
    // backgroundImage: `url(${require("../assets/img/background-1.svg")})`,
    backgroundRepeat: "no-repeat",
  },
});

const switchRoutes = (path) => {
  return (
    <Switch>
      {routes.map((prop, key) => {
        if (prop.layout === path) {
          return (
            <Route
              path={prop.layout + prop.path}
              component={prop.component}
              key={key}
            />
          );
        }
        return null;
      })}
      <Redirect from={path} to={'/dashboard'} />
    </Switch>
  );
};

const Auth = ({ path }) => {
  const classes = styles();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [isAuthenticated]);
  console.log('isMobile', isMobile);
  console.log('auth', isAuthenticated);
  console.log('test', isLoggedIn);
  console.log('width', window.innerWidth);
  return (
    <>
    <Helmet>
     {isMobile && isLoggedIn  ? <meta name="viewport" content="width=device-width, initial-scale=0.5" /> : <meta name="viewport" content="width=device-width, initial-scale=1" />}

    </Helmet>
      <div className={classes.authContainer}>
        <div className={classes.bg}>{switchRoutes(path)}</div>
      </div>
    </>
  );
};

Auth.propTypes = {
  path: PropTypes.string,
};

export default Auth;
